/* eslint-disable */
import createIcon from '../createIcon';

const IconInfoCircleFilled = createIcon({
  name: 'icon-info-circle-filled',
  content: '<path d="M512 64a448 448 0 110 896 448 448 0 010-896zm32 354.944h-64V768h64V418.944zM512 256a38.4 38.4 0 10-.128 76.672A38.4 38.4 0 00512 256z" fill="currentColor"/>',
  width: 1024,
  height: 1024
});
export default IconInfoCircleFilled;
